<template>
  <div
    class="glass-frosted p-6 rounded-6xl flex flex-col text-s-medium text-text-explanatory-default w-184"
  >
    <!-- 根据环境动态渲染不同的缺省状态 -->
    <ClientEmptyState v-if="isElectronEnv" />
    <WebEmptyState v-else :is-scanning="isScanning" @scan="handleScan" />
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDeviceStore } from '@/stores/device'
  import { isElectron } from '@/utils/env'
  import ClientEmptyState from './ClientEmptyState.vue'
  import WebEmptyState from './WebEmptyState.vue'

  const deviceStore = useDeviceStore()
  const { isScanning } = storeToRefs(deviceStore)

  const isElectronEnv = computed(() => isElectron())

  const handleScan = async () => {
    await deviceStore.scan()
  }
</script>
